// extracted by mini-css-extract-plugin
module.exports = {"countdownMessage":"index_countdownMessage__1dBSf","updateButton":"index_updateButton__KeblD","disabled":"index_disabled__3LGnN"};